import React from 'react'
import PropTypes from 'prop-types'

import { sendTrackingEvent } from '$utils/tracking'

const CLICK_EVENT = 'Brand Click'
const IMPRESSION_EVENT = 'Brand Impression'
const CLICKABLE_IMPRESSION_EVENT = 'Brand Impression Clickable'

// TODO: to refactor because global variable is a bad practice...
// If the context was a true webapp, it should be set in global state of application
window.BRANDS_ON_PAGE = []

const handleUserIdList = (userId) => {
  const pattern = `_${userId}_`
  if (!window.BRANDS_ON_PAGE.includes(pattern)) {
    window.BRANDS_ON_PAGE.push(pattern)
  }
}

class SponsorshipTracker extends React.Component {
  state = {
    sentEvents: [],
  }

  constructor(props) {
    super(props)
    this.ref = React.createRef()
    this.observer = null
  }

  componentDidMount() {
    handleUserIdList(this.props.userId)

    const options = {
      rootMargin: '0px',
      threshold: 0.5,
    }
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.trackImpression()
          observer.unobserve(entry.target)
        }
      })
    }, options)
  }

  componentWillUnmount() {
    if (this.observer && this.ref.current) {
      this.observer.unobserve(this.ref.current)
    }
  }

  track = (eventType, eventPosition, userId, data = {}) => {
    sendTrackingEvent('Brand visibility', eventType, {
      event: 'BRANDevent',
      eventLabel: `_${userId}_`,
      logoId: eventPosition,
      ...data,
    })

    this.setState({ sentEvents: [...this.state.sentEvents, eventType] })
  }

  trackImpression = () => {
    let eventType

    if (!this.props.clickEventConfig.enable) {
      eventType = IMPRESSION_EVENT
    } else {
      eventType = CLICKABLE_IMPRESSION_EVENT
    }

    if (this.props.impressionEventConfig.sendOnce && !this.state.sentEvents.includes(eventType)) {
      this.track(eventType, this.props.position, this.props.userId, { nonInteractionEvent: true })
    }
  }

  trackClick = (event) => {
    if (this.props.clickEventConfig.sendOnce && !this.state.sentEvents.includes(CLICK_EVENT)) {
      const linkUrl = event && event.target.href
      this.track(CLICK_EVENT, this.props.position, this.props.userId, { linkUrl })
    }
  }

  render() {
    const { children, clickEventConfig, impressionEventConfig, position, userId, ...props } = this.props

    let enhancedChildren

    if (clickEventConfig.enable) {
      let newOnClickProp
      if (children.props.onClick) {
        newOnClickProp = (event) => {
          this.trackClick(event)
          children.props.onClick(event)
        }
      } else {
        newOnClickProp = this.trackClick
      }

      enhancedChildren = React.cloneElement(children, {
        onClick: newOnClickProp,
        onContextMenu: this.trackClick,
      })
    } else {
      enhancedChildren = children
    }

    if (impressionEventConfig.enable) {
      return <div ref={this.ref}>{enhancedChildren}</div>
    } else {
      return enhancedChildren
    }
  }
}

SponsorshipTracker.defaultProps = {
  clickEventConfig: {
    enable: true,
    sendOnce: true,
  },
  impressionEventConfig: {
    enable: true,
    sendOnce: true,
  },
}

SponsorshipTracker.propTypes = {
  clickEventConfig: PropTypes.shape({
    enable: PropTypes.bool,
    sendOnce: PropTypes.bool,
  }),
  impressionEventConfig: PropTypes.shape({
    enable: PropTypes.bool,
    sendOnce: PropTypes.bool,
  }),
  position: PropTypes.string.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

export default SponsorshipTracker
